import { assignProps, removeItemByCode } from '@/utils/resultsHelper';
import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';
import { findDictionaryMarkdown } from './state';

const fetchDictionaryMarkdown = withDraft((draft, action) => {
  const item = findDictionaryMarkdown(draft, action);

  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.markdowns[action.category].results.push({
      code: action.code,
      datasetCode: action.datasetCode,
      readErrors: [],
      readStatus: states.PENDING,
    });
  }
});

const fetchDictionaryMarkdownSuccess = withDraft((draft, action) => {
  const item = findDictionaryMarkdown(draft, action);
  assignProps(item, {
    ...action.result,
    readErrors: [],
    readStatus: states.SUCCESS,
  });
});

const fetchDictionaryMarkdownError = withDraft((draft, action) => {
  const item = findDictionaryMarkdown(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const closeDictionaryMarkdown = withDraft((draft, action) => {
  const item = findDictionaryMarkdown(draft, action);
  if (item) {
    draft.markdowns[action.category].results = removeItemByCode(draft.markdowns[action.category].results, item);
  }
});

export default {
  [actions.CLOSE_DICTIONARY_MARKDOWN]: closeDictionaryMarkdown,
  [actions.FETCH_DICTIONARY_MARKDOWN]: fetchDictionaryMarkdown,
  [actions.FETCH_DICTIONARY_MARKDOWN_ERROR]: fetchDictionaryMarkdownError,
  [actions.FETCH_DICTIONARY_MARKDOWN_SUCCESS]: fetchDictionaryMarkdownSuccess,
};
